module.exports = __webpack_public_path__ + "media/tr.2d5c9a8f.mp3";